/* ==================================================
 * Animations on Scroll
 * ==================================================*/

(function () {

  'use strict';

  var $target = $('[data-animation-scroll="true"]');
  var $body = $('body');
  var scrollTop = false;

  (function checkScroll() {
    $body.scrollTop(0);
    $target.slice(1).removeClass('animation--in');
    return scrollTop = true;
  })();

  function scrollAnimation() {
    if (scrollTop === true) {
      $target.each(function () {
        var $this = $(this);
        var itemOffset = $this.offset().top;

        $(window).on('scrollHandler', function (ev, args) {
          if (($(window).scrollTop() + ($(window).height() + ($(window).height() * 0.2))) >= (itemOffset)) {
            $this.addClass('animation--in');
          }
        });
      });

      $(window).trigger('scrollHandler');
    }
  }

  scrollAnimation();
})();
